import styled, { css } from 'styled-components'

import { COLORS } from '@treelab/panda'

export const Container = styled.div`
  margin-top: 16px;
`;

export const TitleContainer = styled.div`
  margin-bottom: 8px;
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Vertical = styled.div`
  margin-right: 5px;
  width: 1px;
  height: 14px;
  border-radius: 2px;
  border: 1px solid ${COLORS.greyLight2};
  background-color: ${COLORS.greyLight2};
`;

const TitleMainHoverMixin = css`
  cursor: pointer;
  background-color: ${COLORS.greyLight4};
`;

export const TitleMain = styled.div<{ allowFolding: boolean }>`
  padding: 6px 12px 6px 8px;
  display: inline-flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.greyDark1};
  border-radius: 4px;

  &:hover {
    ${(props) => ( props.allowFolding && TitleMainHoverMixin )};
  }
` 

export const ChildrenContainer = styled.div<{ show: boolean }>`
  padding-right: 8px;
  padding-left: 16px;
  display: ${(props) => (props.show ? 'block' : 'none')};
`
